import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";

/**
 * Contact list filters
 */
export class ContactsListFilter {
	constructor(public hideArchivedContacts: boolean) {}

	static empty(): ContactsListFilter {
		return new ContactsListFilter(true);
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {ContactsListFilter}
	 */
	static getFromLocalStorageData(data: any): ContactsListFilter {
		if (!isDefined(data)) {
			return ContactsListFilter.empty();
		}
		const showArchivedContacts = isDefined(data.hideArchivedContacts) ? data.hideArchivedContacts : true;
		return new ContactsListFilter(showArchivedContacts);
	}

	updateArchivedContacts(value: boolean): ContactsListFilter {
		this.hideArchivedContacts = value;
		LocalStorage.saveContactsListFilters(this);
		return this;
	}
}
